import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import close from "../../assets/landing_page/new/closeicon.svg";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function GenericDialog(props) {
  const {
    open,
    onClose,
    title,
    content,
    maxWidth,
    button,
    noBackGround,
    fullScreen,
  } = props;
  return (
    <div>
      <BootstrapDialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth={maxWidth}
        // onClose={onClose}
        onClose={(e, r) => {
          if (r && r === "bacldropClick") return onClose(e);
        }}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby='customized-dialog-title'
        open={open}
        sx={{ padding: noBackGround && 0 }}>
        {title ? (
          <>
            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "black",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "50%",
                },
              }}>
              <img
                src={close}
                alt='PlanShare Logo'
                style={{ width: "20px", height: "20px" }}
              />
              {/* <CloseIcon /> */}
            </IconButton>
          </>
        ) : (
          <>
            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "black",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.12)",
                  borderRadius: "50%",
                },
              }}>
              <CloseIcon />
            </IconButton>
          </>
        )}

        <DialogContent
          sx={{ padding: noBackGround && "0px !important" }}
          dividers>
          {content}
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}

GenericDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  buttonText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
